import type { Content, ContentImageFields } from '@beat-venues/common-types';
import {
    ContentfulImage,
    type ContentfulImageProps,
} from '../contentful-image';

import type { JSX } from 'react';

export interface ContentfulContentImageProps
    extends Pick<
        ContentfulImageProps,
        | 'width'
        | 'className'
        | 'wrapperClassName'
        | 'testId'
        | 'rounded'
        | 'sizes'
    > {
    data: Content<'contentImage', ContentImageFields>;
    showCaption?: boolean;
}

export const ContentfulContentImage = ({
    data,
    width,
    rounded,
    testId = 'contentful-content-image',
    className,
    wrapperClassName,
    sizes,
    showCaption = true,
}: ContentfulContentImageProps): JSX.Element | null => {
    const figCaption = showCaption ? data.fields.caption : undefined;

    return data.fields.image?.fields?.file ? (
        <ContentfulImage
            data-testid={testId}
            wrapperClassName={wrapperClassName}
            className={className}
            isSvg={
                data.fields.image.fields.file.contentType === 'image/svg+xml'
            }
            alt={data.fields.altText}
            src={data.fields.image.fields.file.url}
            width={width ?? data.fields.image.fields.file.details.image?.width}
            caption={figCaption}
            rounded={rounded}
            sizes={sizes}
        />
    ) : null;
};
